import { placeholder } from 'src/app/models/placeholder';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NavController } from '@ionic/angular';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'product-card-list',
  templateUrl: './product-card-list.component.html',
  styleUrls: ['./product-card-list.component.scss'],
})
export class ProductCardListComponent implements OnInit {
  @Input() productsList: any;
  @Input() noPaging: boolean;
  @Input() currencyCode: any;
  @Input() navigateUrl: string;
  @Output() getNextPage = new EventEmitter<Event>();
  imagePlaceholder = placeholder;
  constructor(
    private navControl: NavController,
    private i18ConfigService: I18ConfigService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}

  navigateToNextPage(productItem) {
    this.analyticsService.trackUnified('product_card_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'product_card_clicked',
      component: 'product-card-list-component',
    });
    this.navControl.navigateForward([
      this.navigateUrl,
      productItem.id,
      { loc: productItem.locationId, storeId: productItem.storeId },
    ]);
  }

  getNextPageFromParent(event) {
    this.getNextPage.emit(event);
  }
}
